import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AvaliacaoAulaComponent } from './avaliacao-aula/avaliacao-aula.component';
import { ListagemAulaComponent } from './listagem-aula/listagem-aula.component';
import { PreAulaComponent } from './pre-aula/pre-aula.component';
import { SalaDeAulaComponent } from './sala-de-aula/sala-de-aula.component';

const routes: Routes = [
  {
    path: '',
    component: ListagemAulaComponent,
  },
  {
    path: 'pre-aula/:id',
    component: PreAulaComponent,
  },
  {
    path: 'sala-de-aula/:id',
    component: SalaDeAulaComponent,
  },
  {
    path: 'avaliar-aula/:id',
    component: AvaliacaoAulaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AulaRoutingModule {}
